import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_BUSINESS_PARTNERS}`;

const request = async (method, endpoint, data = null, params = null) => {
  const url = `${BASE_URL}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, params, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};

export const sectors_get = () => request("get", "/od/sectors");

export const sectors_post = (data) => request("post", "/od/sectors", data);

export const sectors_put = (id, data) => request("put", `/od/sectors/${id}`, data);

export const sectors_delete = (id) => request("delete", `/od/sectors/${id}`);

export const pos_sector_get = () => request("get", `/od/sectors/${sessionStorage.getItem("id_sector")}/pos?include_address=true`);

export const sectors_pos_post = (id, data) => request("post", `/od/sectors/${id}/pos`, data);

export const pos_sector_delete = (id) => request("delete", `/od/sectors/${sessionStorage.getItem("id_sector")}/pos/${id}`);




export const sectors_ById_get = (id) => request("get", `/od/sectors/${id}`);

export const sectors_ById_pos_get = (id) => request("get", `/od/sectors/${id}/pos`);

export const sectors_ById_pos_post = (id, data) => request("post", `/od/sectors/${id}/pos`, data);

export const sectors_ById_pos_delete = (id, idpos) => request("delete", `/od/sectors/${id}/pos/${idpos}`);

export const sectors_ById_pos_one_get = (id, idpos) => request("get", `/od/sectors/${id}/pos/${idpos}`);

export const sectors_ById_pos_put = (id, idpos, data) => request("put", `/od/sectors/${id}/pos/${idpos}`, data);

export const array_pos_sector_post = (id, data) => request("post", `/od/sectors/${id}/pos/update-from-file`, data);
